//import './select.css'
import React from "react";
import { useTranslation } from "react-i18next";
import InputValidationFactory from "../../../../factorys/inputvalidation/InputValidationFactory";
import { IInputValidationItemProps, IInputValidatorItem } from "../../../../factorys/inputvalidation/interfaces/InputValidationInterfaces";
import { InputValidation } from "../../../../factorys/inputvalidation/InputValidation";
import { SelectCustomControllerType1 } from "./SelectCustomControllerType1";
import CSSClassSerivce from "../../../../services/CommonCSSSerivce";
import TextInputType1 from "../text/TextInputType1";
import { ToolTip } from "../../../../tooltip/ToolTip";
import { EInputValidationResultType } from "../../../../factorys/inputvalidation/enums/InputValidationEnums";

interface ISelectCustomInputProps extends IInputValidationItemProps {
  label?: string;
  name?: string;
  readOnly?: boolean;
  required?: boolean;
  value: string | undefined;
  classNameInput: string;
  listBGColor?: string;
  disabledAddClass?: string;
  options: string[];
  onInit?: () => void;
  onInputChange?: ((it: string) => void) | null;
  disabled?: boolean | undefined;
  onInputValidation?: ((it: EInputValidationResultType) => void) | null;
  validationItems?: IInputValidatorItem[] | null;
  getColorByOption?: (it?: string) => string;
}

const SelectCustomType1: React.FC<ISelectCustomInputProps> = (props) => {


  const { t } = useTranslation();
  //init controllers
  const c = SelectCustomControllerType1<string>({
    value: props.value,
    //onMount: () => { ivc?.validate({ value: props.value }) },
    disabled: props.disabled,
    classNameFrame: "",
    classNameInput: props.classNameInput,
    //classNameInput: "",
    disabledClass: props.disabledAddClass ? props.disabledAddClass : ""
    //disabledClass: ""
  })

  const ivc = InputValidationFactory.getInputValidationController({
    validationItems: props.validationItems,
    itemProps: props,
    itemController: c,
    onMount: () => { ivc?.validate({ value: props.value, ignoreBlur: false }) }
  });

  //props.onInputChange?props.onInputChange(props.)

  if (props.value == null) return <></>
  //set default value
  props.onInit ? props.onInit() : null
  //props.onInputChange?props.onInputChange(props.value):null
  //const defaultValue = 

  const getToolTipContent = (option: string): JSX.Element | null => {

    const key = option + "_tooltip";
    const result = t(option + "_tooltip")

    if (result == key) return null

    return <>{result}</>
  }

  const getListItems = (): JSX.Element | null => {
    if (props.readOnly) return <></>;

    return <div className={`${!c.focused ? "collapse" : "z-20 w-full"} `} >
      <ul
        id={props.name}
        key={props.value}
        ref={(it) => c.setRefInput(it)}
        className={`absolute w-full overflow-visible border-gray-500 rounded-lg text-center border-2 cursor-pointer ${props.listBGColor ? props.listBGColor : "bg-white"} z-10`}
        defaultValue={props.value}
      >

        {props.options.map((option, index) => (<>
          <li
            key={index}
            //className={`hover:bg-gray-300 p-0 border-4 border-${props.getColorByOption?props.getColorByOption(option):""}`}
            className={`hover:text-bluec flex items-center justify-center text-center rounded-md px-4 m-1 overflow-hidden bg-${props.getColorByOption ? props.getColorByOption(option) : ""}`}
            value={option}
            onBlur={(e) => {
              ivc?.strValidationIsVisible(option)
              //c.setFocused(false)
              //props.fOnBlur?props.fOnBlur():null
              c.setBlur(true);
            }}
            onClick={(it) => {
              ivc?.validate({ value: option, ignoreBlur: true });
              props.onInputChange ? props.onInputChange(option) : {}
              c.setValue(option)
              c.setFocused(false)
            }}
          >
            <>
              <ToolTip
                content={getToolTipContent(option)}
                classNameAdd="z-10"
                pos={[0, -6]}
              >
                <div
                  key={index}
                //className={"relative"} style={{"left": `${(2.5).toString()}rem`, "top": `${(0.5).toString()}rem` }} 
                >
                  {t(option)}
                </div>

              </ToolTip>
            </>
          </li>
        </>

        ))}

      </ul>


    </div>

  }

  return (
    <div
      className={"w-full flex flex-col relative"}
      //className={"dropdown"}
      onMouseLeave={(e) => { c.setFocused(false) }}
    >
      {/* {props.label?
          <label htmlFor={props.name} className="text-xs font-medium flex flex-row">
            {t(props.label)}
            <p className="pl-1">{props.required ? " *" : ""}</p>
          </label>:<></>
        } */}

      <TextInputType1
        
        readOnly={true}
        //testId = {props.testId}
        keyStart={c.value}
        type={"text"}
        hideLabel={false}
        //label={props.label}
        disabled={props.readOnly ? props.readOnly : props.disabled ? props.disabled : false}
        //placeholder={props.placeholder}
        name={props.name}
        defaultValue={t(c.value!!)}
        required={props.required}

        classNameInput={`${CSSClassSerivce.textInputClass} bg-opacity-75 bg-${props.getColorByOption ? props.getColorByOption(c.value) : ""}`}
        disabledAddClass={CSSClassSerivce.disabledAddClass}
        fOnFocus={() => { c.setFocused(true) }}
        fOnClick={() => { c.setFocused(true) }}
      />

      {getListItems()}



      {(ivc != null) ? <InputValidation ivc={ivc} /> : <></>}


    </div>
  );
};

export default SelectCustomType1;
